import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ProductBranding } from './product-branding';
import { PRODUCT_BRANDING } from './product-branding.token';

/** Sets the document title to the title of the product being served. */
export function provideProductTitle(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (title: Title, branding: ProductBranding) => () => title.setTitle(branding.title),
      deps: [Title, PRODUCT_BRANDING]
    }
  ]);
}
